<template>
  <div class="col-12 col-md-12 col-lg-10" v-if="banks.length > 0">
    <h5 style="text-align: center; margin: -30px auto 40px auto;">Os dados informados devem ser do titular da conta.</h5>
    <form @submit.prevent="submit">
      <!--<div class="bancos-new" style="margin-bottom: 30px;">
        <label v-for="(banco, i) in mainBanks" :key="`mainBank${i}`" class="banco-principal">
          <input :value="banco.codigo" v-model="bankCode" name="banco" type="radio" class="banco-principal-input"/>
          <img :src="banco.logo" class="banco-principal-logo borda"/>
        </label>
        <label class="banco-principal">
          <input :checked="isOtherBank" @change="aoMudarEhOutroBanco" type="radio" class="banco-principal-input"/>
          <img src="/static/assets/images/outro-banco.png" class="banco-principal-logo"/>
        </label>
      </div> -->
      <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-6">
          <at-select size="large" tabindex="1" class="focus-select" v-model="bankCode" filterable placeholder="Banco">
            <at-option v-for="(banco, i) in banks" :key="`bankOptions${i}`" :value="banco.codigo">{{banco.nome}}</at-option>
          </at-select>
          <div class="form-row">
            <div class="form-group col-12 col-md-6">
              <label for="agencia">Agência *<strong v-if="selectedBank.codigo == '077'" style="color: #41d3bd"> sem o digito 9</strong></label>
              <input key="agency" tabindex="2" type="text" class="form-control form-control-lg" v-model="agency" v-mask="selectedBank.agencia" v-bind:placeholder="selectedBank.placeholderAgencia" required>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="inputPassword4">Conta *<strong v-if="selectedBank.codigo == '104'" style="color: #41d3bd"> (X: Operação)</strong></label>
              <input type="text" tabindex="3" class="form-control form-control-lg" v-model="account" v-mask="selectedBank.conta" v-bind:placeholder="selectedBank.placeholderConta" required>
            </div>
            <div class="form-group col-12 col-md-12 align-self-center text-center">
              <div class="form-check form-check-inline">
                <div class="checkContainer d-flex align-items-center" style="height:25px;">
                  <input class="form-check-input" tabindex="4" type="radio" name="TipoConta" v-model.number="accountType" id="cc" value="1" required>
                  <span class="checkmark"></span>
                  <label class="form-check-label" for="cc">Conta corrente</label>
                </div>
              </div>
              <div class="form-check form-check-inline">
                <div class="checkContainer d-flex align-items-center" style="height:25px;">
                  <input class="form-check-input" tabindex="5" type="radio" name="TipoConta" v-model.number="accountType" id="cp" value="2" required>
                  <span class="checkmark"></span>
                  <label class="form-check-label" for="cp">Conta poupança</label>
                </div>
              </div>
            </div>
          </div>
          <div class="btns text-center">
            <!-- <button type="button" class="btn btn-lg btn-link" @click="submeterSemConta"><span class="icon icon-x"></span> Não tenho conta</button> -->
            <div class="text-center fixedOptions">
              <button class="btn btn-lg btn-primary">Próximo <img src="/static/assets/images/angle-right.svg"></button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
@import "../assets/styles/iouu/mixins";

@include xs {
  .steps {
    .form-check {
      padding-left: 10px;
    }
  }

  .form-check-inline + .form-check-inline {
    margin-left: 0;
  }
}

  .banco-principal {
    display: inline-block;
    margin: 6px;
    cursor: pointer;

    img {
      border-radius:100px;
      width: 65px;
      height: 65px;
    }
  }

  .banco-principal-input {
    &:not(checked) ~ .banco-principal-logo {
      opacity: 0.1;
    }

    &:not(checked) {
      display: none;
      padding:0px;
      margin:0px;
    }

    &:checked ~ .banco-principal-logo {
      opacity: 1;
    }
  }

  .btns {
    margin-top: 20px;
  }

  .borda {
    border: solid 1px rgba(0, 0, 0, 0.1);
  }

  .bancos-new {
    display: flex;
    justify-content: center;
    width: 70%;
    margin: 0 auto;
    flex-wrap: wrap;
  }

</style>

<script>
/* eslint-disable */
import HubConsultaClient from '@/utils/hub-consulta-client'

import logoBancoDoBrasil from '../../static/assets/images/bancos/ico-bb.png'
import logoCaixa from '../../static/assets/images/bancos/ico-caixa.png'
import logoItau from '../../static/assets/images/bancos/ico-itau.png'
import logoBradesco from '../../static/assets/images/bancos/ico-bradesco.png'
import logoSantander from '../../static/assets/images/bancos/ico-santander.png'
import logoNeon from '../../static/assets/images/bancos/ico-neon.png'
import logoInter from '../../static/assets/images/bancos/ico-inter.png'
import logoPagSeguro from '../../static/assets/images/bancos/ico-pagseguro.png'
import logoNuBank from '../../static/assets/images/bancos/ico-nubank.png'
import logoSicredi from '../../static/assets/images/bancos/ico-sicredi.png'
import logoBRB from '../../static/assets/images/bancos/ico-brb.png'
import logoSicoob from '../../static/assets/images/bancos/ico-sicoob.png'
import logoViaCredi from '../../static/assets/images/bancos/ico-viacredi.png'
import logoBarisul from '../../static/assets/images/bancos/ico-barisul.png'
import logoOriginal from '../../static/assets/images/bancos/ico-original.png'
import logoStone from '../../static/assets/images/bancos/ico-stone.svg'
import Promise from 'es6-promise'
import * as mutationTypes from '@/store/mutation-types.js'
import {mask} from 'vue-the-mask';

const Moip = window.Moip

export default {
  data() {
    return {
      bankCode: this.bankData.bankCode ? this.bankData.bankCode : '001',
      agency: this.bankData.agency,
      agencyDigit: this.bankData.agency,
      account: this.bankData.account,
      accountType: this.bankData.accountType,
      banks: [],
      selectedBank: {codigo: '001', nome: 'Banco do Brasil S.A.', logo: logoBancoDoBrasil, agencia:'####-#', conta:'########-#', placeholderAgencia: "0000-0", placeholderConta: "00000000-0"},
      mainBanks: [
        {codigo: '001', nome: 'Banco do Brasil S.A.',           logo: logoBancoDoBrasil, agencia:'####-#', conta:'########-#',      placeholderAgencia: "0000-0", placeholderConta: "00000000-0"},
        {codigo: '033', nome: 'Banco Santander (Brasil) S.A.',  logo: logoSantander,     agencia:'####',   conta:'########-#',      placeholderAgencia: "0000",   placeholderConta: "0000000-0"},
        {codigo: '104', nome: 'Caixa Econômica Federal',        logo: logoCaixa,         agencia:'####',   conta:'#############-#', placeholderAgencia: "0000",   placeholderConta: "XXXX 000000000-0"},
        {codigo: '237', nome: 'Banco Bradesco S.A.',            logo: logoBradesco,      agencia:'####-#', conta:'#######-#',       placeholderAgencia: "0000-0", placeholderConta: "0000000-0"},
        {codigo: '341', nome: 'Itaú Unibanco S.A.',             logo: logoItau,          agencia:'####',   conta:'#####-#',         placeholderAgencia: "0000",   placeholderConta: "00000-0"},
        {codigo: '041', nome: 'Banco Banrisul',                 logo: logoBarisul,       agencia:'####',   conta:'#########-#',     placeholderAgencia: "0000",   placeholderConta: "000000000-0"},
        {codigo: '748', nome: 'Sicredi',                        logo: logoSicredi,       agencia:'####',   conta:'######',          placeholderAgencia: "0000",   placeholderConta: "000000"},
        {codigo: '756', nome: 'Sicoob',                         logo: logoSicoob,        agencia:'####',   conta:'#########-#',     placeholderAgencia: "0000",   placeholderConta: "000000000-0"},
        {codigo: '077', nome: 'Banco Intermedium S.A.',         logo: logoInter,         agencia:'####',   conta:'#########-#',     placeholderAgencia: "0000",   placeholderConta: "000000000-0"},
        {codigo: '070', nome: 'BRB',                            logo: logoBRB,           agencia:'####',   conta:'#########-#',     placeholderAgencia: "0000",   placeholderConta: "000000000-0"},
        {codigo: '085', nome: 'Via Credi',                      logo: logoViaCredi,      agencia:'####',   conta:'###########-#',   placeholderAgencia: "0000",   placeholderConta: "00000000000-0"},
        {codigo: '655', nome: 'Banco Neon',                     logo: logoNeon,          agencia:'####',   conta:'#######-#',       placeholderAgencia: "0000",   placeholderConta: "0000000-0"},
        {codigo: '260', nome: 'NuBank',                         logo: logoNuBank,        agencia:'####',   conta:'#######-#',       placeholderAgencia: "0000",   placeholderConta: "0000000-0"},
        {codigo: '290', nome: 'PagSeguro',                      logo: logoPagSeguro,     agencia:'####',   conta:'########-#',      placeholderAgencia: "0000",   placeholderConta: "00000000-0"},
        {codigo: '212', nome: 'Banco Original',                 logo: logoOriginal,      agencia:'####',   conta:'#####-#',         placeholderAgencia: "0000",   placeholderConta: "00000-0"},
        {codigo: '197', nome: 'Stone Pagamentos S.A.',          logo: logoStone,         agencia:'####',   conta:'#######-#',       placeholderAgencia: "0000",   placeholderConta: "0000000-0"}
      ]
    }
  },
  directives: {mask},
  props: {
    bankData: {required: true, type: Object}
  },
  computed: {
    isOtherBank: {
      get: function() {
        return this.mainBanks.find(bank => { return bank.codigo == this.bankCode }) == null
      },
      set: function() {
        this.bankCode = ''
      }
    }
  },
  methods: {
    aoMudarEhOutroBanco() {
      this.bankCode = ''
    },
    submeterSemConta() {
      const newData = {
        bankData: null,
        hasNoAccount: true
      }
      this.$emit('submit', newData)
    },
    trimBankAccountStart(account, maxNumCount) {
      let splitedAccount = account.split("-");

      let len = splitedAccount.length > 1 ? splitedAccount[0].length + splitedAccount[1].length : splitedAccount[0].length;

      console.log('Len: ' + len)

      let zeroCount = maxNumCount - len;
      let leftZero = ''

      for (let i = 0; i <= zeroCount; i++) {
        leftZero += '0';
      }

      let result = leftZero + account;
      console.log("leftZero + account: " + result)

      if (splitedAccount.length <= 1) {
        let hifen = result.length

        result = result.slice(0, hifen-1) + '-' + result.slice(hifen-1)
        console.log('result: ' + result)
      }

      return result;
    },
    trimBankAgencyStart(agency, maxNumCount) {
      let splitedAgency = agency.split("-");

      let len = splitedAgency.length > 1 ? splitedAgency[0].length + splitedAgency[1].length : splitedAgency[0].length;

      console.log('Len: ' + len)

      let zeroCount = maxNumCount - len;
      let leftZero = ''

      for (let i = 0; i <= zeroCount; i++) {
        leftZero += '0';
      }

      let result = leftZero + agency;
      console.log("leftZero + agency: " + result)

      if (maxNumCount === 4 && splitedAgency.length <= 1) {
        let hifen = result.length

        result = result.slice(0, hifen-1) + '-' + result.slice(hifen-1)
        console.log('result: ' + result)
      }

      return result;
    },
    validate() {
      var agencyCheckNumber = '';

      if(this.bankCode == '001' || this.bankCode == '237') {
        // if(this.agency.split("-").length == 1) {
        //   var len = this.agency.length;
        //   this.agency = this.agency.slice(0, len - 1) + '-' + this.agency.slice(len - 1);
        // }

        // //banco do brasil e bradesco possuem dígito na agência
        
        this.agency = this.trimBankAgencyStart(this.agency, 4)
        agencyCheckNumber = this.agency.split("-")[1];
      } else
        this.agency = this.trimBankAgencyStart(this.agency, 3)

      if(this.bankCode == '748') {
        var accountNumberDigit =  this.account[this.account.length - 1]
      }

      if(this.bankCode == '001' || this.bankCode == '033')
        this.account = this.trimBankAccountStart(this.account, 8)
      else if (this.bankCode == '237')
        this.account = this.trimBankAccountStart(this.account, 7)
      else if (this.bankCode == '341')
        this.account = this.trimBankAccountStart(this.account, 5)
      else
        this.account = this.trimBankAccountStart(this.account, 11)

      console.log("AG ", agencyCheckNumber)

      return new Promise((resolve) => {
        Moip.BankAccount.validate({
          bankNumber         : this.bankCode,
          agencyNumber       : this.agency.split("-")[0],
          agencyCheckNumber  : agencyCheckNumber,
          accountNumber      : this.account.split("-")[0],
          accountCheckNumber : accountNumberDigit ? accountNumberDigit : this.account.split("-")[1],
          valid: () => {
            resolve({isValid: true, errors: []})
          },
          invalid: (data) => {
            const errors = Array.map(data.errors, error => {
              return error.description
            })
            resolve({isValid: false, errors: errors})
          }
        })
      })
    },
    submit() {
      this.validate()
        .then(validation => {
          if(validation.isValid) {
            const newData = {
              bankCode: this.bankCode,
              agency: this.agency,
              account: this.account,
              accountType: this.accountType,
              hasNoAccount: false
            }

            

            this.$emit('submit', newData)
          } else {
            this.$Notify.error({
              title: "Dados Inválidos",
              message: validation.errors.map(error => error.replace(/\.\s([A-Z])/, (match, cg1) => `, ${cg1.toLowerCase()}`)).join(' ')
            })
          }
        })
    }
  },
  watch: {
    bankCode: function (newValue) {
      let Bank = this.mainBanks.filter(bank => newValue == bank.codigo )
      console.log(Bank[0].agencia)
      this.agency = ''
      this.account = ''
      this.selectedBank = Bank[0];
    }
  },
  beforeCreate() {
    this.$store.commit(mutationTypes.START_LOADING)
    HubConsultaClient.pegarBancos()
      .then(banks => {
        this.banks = banks
        this.$store.commit(mutationTypes.STOP_LOADING)
        this.banks = this.mainBanks;
        if(this.bankData.bankCode) {
          this.selectedBank = this.banks.filter( bank => bank.codigo == this.bankData.bankCode)[0]
        }
      })
      .catch(error => {
        console.log("Error", error);
        this.$store.commit(mutationTypes.STOP_LOADING)
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BankDataForm.vue